exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vx-auto-suggest{\n  position:relative\n}\n.vx-auto-suggest .vs-input .vs-con-input .vs-inputx{\n  z-index:10\n}\n.vx-auto-suggest .vs-input .vs-con-input .vs-input--placeholder{\n  top:0;\n  z-index:50\n}\n.vx-auto-suggest .auto-suggest-suggestions-list{\n  position:absolute;\n  background:#fff;\n  width:100%;\n  max-height:82vh;\n  overflow-y:auto\n}\n.vx-auto-suggest .auto-suggest-suggestions-list .auto-suggest__suggestion-group__suggestion.vx-auto-suggest__current-selected{\n  background:#f1f1f1\n}", ""]);

// exports
